<div class="sidenav" [ngClass]="{'collapsed-sidebar': isCollapsed, 'sidebar': !isCollapsed}">
    <mat-drawer-container class="drawer-container">
        <mat-drawer class="drawer side-bar-class" mode="side" opened>
            <div class="drawer__header">
                <div class="drawer__header--icon">
                    <div class="hamburger-menu">
                        <mat-icon class="chevron-button" [ngClass]="{'rotated': isCollapsed}"
                            (click)="toggleSidebar()">chevron_left</mat-icon>
                    </div>
                    <img class="ps4-icon" src="assets/images/sect4-logo.svg" alt="Primaria Sectorului 4" />
                    <div class="drawer__header--text">
                        <div class="drawer__header--text--title">{{appName}}</div>
                        <div class="drawer__header--text--title--minWidth">PS 4</div>
                        <div class="drawer__header--text--subtitle faded-text">
                            {{appDescription}}
                        </div>
                        <div class="drawer__header--text--subtitle--minWidth faded-text">
                            PO
                        </div>
                    </div>
                </div>
            </div>
            <div class="drawer__buttons">
                <mat-accordion>

                    <p routerLink="/aplicatii" class="menu-link" [class.menu-active]="'/aplicatii' === activeOption"
                        (click)="setActive('/aplicatii')">
                        <img src="/assets/icons/apps.svg" alt="" />
                        <span>Aplicații</span>
                    </p>
                    <p *ngIf="permissionsService.hasPermission('auth-module.gallery.list')" routerLink="/galerie"
                        class="menu-link" [class.menu-active]="'/galerie' === activeOption"
                        (click)="setActive('/galerie')">
                        <img src="/assets/icons/gallery.svg" alt="" />
                        <span>Galerie</span>
                    </p>
                    <p routerLink="/settings" class="menu-link" [class.menu-active]="'/settings' === activeOption"
                        (click)="setActive('/settings')">
                        <img src="/assets/icons/settings.svg" alt="" />
                        <span>Setări</span>
                    </p>

                    <mat-expansion-panel class="sidenav-accordion" (opened)="panelOpenState3 = true"
                        (closed)="panelOpenState3 = false">
                        <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState3">
                            <mat-panel-title class="sidenav-accordion">
                                <img src="/assets/icons/cetatean.svg" alt="" />
                                <span>Instituții</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p *ngIf="permissionsService.hasPermission('auth-module.clients.list')" routerLink="/clienti"
                            class="settings-option-menu" [class.menu-active]="'/clienti' === activeOption"
                            (click)="setActive('/clienti')">
                            <img src="/assets/icons/clients.svg" alt="" />
                            <span>Permisiuni Instituții</span>
                        </p>
                        <p class="settings-option-menu" routerLink="/documente-publice"
                            [class.menu-active]="'/documente-publice' === activeOption"
                            (click)="setActive('/documente-publice')">
                            <img src="/assets/icons/confirmed-docs.svg" alt="" />
                            <span>Documente Publice</span>
                        </p>
                        <p class="settings-option-menu" routerLink="/operatori-institutii"
                            [class.menu-active]="'/operatori-institutii' === activeOption"
                            (click)="setActive('/operatori-institutii')">
                            <img src="/assets/icons/confirmed-docs.svg" alt="" />
                            <span>Operatori Instituții</span>
                        </p>
                        <p class="settings-option-menu" routerLink="/institutii-settings"
                            [class.menu-active]="'/institutii-settings' === activeOption"
                            (click)="setActive('/institutii-settings')">
                            <img src="/assets/icons/settings.svg" alt="" />
                            <span>Setări</span>
                        </p>
                    </mat-expansion-panel>
                    <mat-expansion-panel *ngIf="permissionsService.hasPermission('auth-module.bulevart.bulevart-gallery.list') || 
                            permissionsService.hasPermission('auth-module.bulevart-settings.access')
                        " class="sidenav-accordion" (opened)="panelOpenState5 = true"
                        (closed)="panelOpenState5 = false">
                        <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState5">
                            <mat-panel-title class=" sidenav-accordion">
                                <img src="/assets/icons/bulevart.svg" alt="" />
                                <span>Bulevart</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p *ngIf="permissionsService.hasPermission('auth-module.bulevart.bulevart-gallery.list')"
                            class="settings-option-menu" routerLink="/bulevart-gallery"
                            [class.menu-active]="'/bulevart-gallery' === activeOption"
                            (click)="setActive('/bulevart-gallery')">
                            <img src="/assets/icons/gallery.svg" alt="" />
                            <span>Galerie</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.bulevart-settings.access')"
                            class="settings-option-menu" routerLink="/bulevart-settings"
                            [class.menu-active]="'/bulevart-settings' === activeOption"
                            (click)="setActive('/bulevart-settings')">
                            <img src="/assets/icons/settings.svg" alt="" />
                            <span>Setări</span>
                        </p>
                    </mat-expansion-panel>
                    <mat-expansion-panel *ngIf="permissionsService.hasPermission('auth-module.solicitari.list') || 
                            permissionsService.hasPermission('auth-module.pre-inrolati.list') ||
                            permissionsService.hasPermission('auth-module.citizen.list') ||
                            permissionsService.hasPermission('auth-module.beneficiari.list') ||
                            permissionsService.hasPermission('auth-module.sablon-cerere.list')
                        " class="sidenav-accordion" (opened)="panelOpenState1 = true"
                        (closed)="panelOpenState1 = false">
                        <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState1">
                            <mat-panel-title class="sidenav-accordion">
                                <img src="/assets/icons/cetatean.svg" alt="" />
                                <span>Cetățean</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p *ngIf="permissionsService.hasPermission('auth-module.solicitari.list')"
                            class="settings-option-menu" routerLink="/requests"
                            [class.menu-active]="'/requests' === activeOption" (click)="setActive('/requests')">
                            <img src="/assets/icons/cereri.svg" alt="" />
                            <span>Solicitări</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.pre-inrolati.list')"
                            class="settings-option-menu" routerLink="/conturi-preinrolate"
                            [class.menu-active]="'/conturi-preinrolate' === activeOption"
                            (click)="setActive('/conturi-preinrolate')">
                            <img src="/assets/icons/user-check.svg" alt="" />
                            <span>Conturi preînrolate</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.citizen.list')"
                            class="settings-option-menu" routerLink="/conturi-cetatean"
                            [class.menu-active]="'/conturi-cetatean' === activeOption"
                            (click)="setActive('/conturi-cetatean')">
                            <img src="/assets/icons/user.svg" alt="" />
                            <span>Conturi cetățean</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.beneficiari.list')"
                            class="settings-option-menu" routerLink="/beneficiari"
                            [class.menu-active]="'/beneficiari' === activeOption" (click)="setActive('/beneficiari')">
                            <img src="/assets/icons/user.svg" alt="" />
                            <span>Beneficiari</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.settings.sabloane-cerere.list')"
                            class="settings-option-menu" routerLink="/sabloane-requests"
                            [class.menu-active]="'/sabloane-requests' === activeOption"
                            (click)="setActive('/sabloane-requests')">
                            <img src="/assets/icons/drawer.svg" alt="" />
                            <span>Șabloane Solicitări</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.solicitari.citizen-documents.list')"
                            class="settings-option-menu" routerLink="/documente-cetatean"
                            [class.menu-active]="'/documente-cetatean' === activeOption"
                            (click)="setActive('/documente-cetatean')">
                            <img src="/assets/icons/docs.svg" alt="" />
                            <span>Documente</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.solicitari.confirmare-documents.list')"
                            class="settings-option-menu" routerLink="/confirmare-documente"
                            [class.menu-active]="'/confirmare-documente' === activeOption"
                            (click)="setActive('/confirmare-documente')">
                            <img src="/assets/icons/confirmed-docs.svg" alt="" />
                            <span>Confirmare Documente</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.solicitari.citizen-documents.list')"
                            class="settings-option-menu" routerLink="/rapoarte"
                            [class.menu-active]="'/rapoarte' === activeOption" (click)="setActive('/rapoarte')">
                            <img src="/assets/icons/rapoarte.svg" alt="" />
                            <span>Rapoarte</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.solicitari.citizen-documents.list')"
                            class="settings-option-menu" routerLink="/borderou"
                            [class.menu-active]="'/borderou' === activeOption" (click)="setActive('/borderou')">
                            <img src="/assets/icons/borderou.svg" alt="" />
                            <span>Borderou</span>
                        </p>
                        <p *ngIf="true" class="settings-option-menu" routerLink="/recenzii"
                            [class.menu-active]="'/recenzii' === activeOption" (click)="setActive('/recenzii')">
                            <img src="/assets/icons/star.svg" alt="" />
                            <span>Recenzii</span>
                        </p>
                    </mat-expansion-panel>
                    <mat-expansion-panel *ngIf="permissionsService.hasPermission('auth-module.ghiseu.list') ||
                                permissionsService.hasPermission('auth-module.ghiseu.ghiseu-dashboard.list') ||
                                permissionsService.hasPermission('auth-module.ghiseu.ghiseu-programari.list') || 
                                permissionsService.hasPermission('auth-module.ghiseu.notificari-ghiseu.list') ||
                                permissionsService.hasPermission('auth-module.ghiseu.borderou-automat.list') ||
                                permissionsService.hasPermission('auth-module.ghiseu-settings.access-ghiseu')
                            " class="sidenav-accordion" (opened)="panelOpenState4 = true"
                        (closed)="panelOpenState4 = false">
                        <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState4">
                            <mat-panel-title class="sidenav-accordion">
                                <img src="/assets/icons/administrative.svg" alt="" />
                                <span>Ghișeul Unic</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p *ngIf="permissionsService.hasPermission('auth-module.ghiseu.ghiseu-dashboard.list')"
                            class="settings-option-menu" routerLink="/ghiseul-unic-dashboard"
                            [class.menu-active]="'/ghiseul-unic-dashboard' === activeOption"
                            (click)="setActive('/ghiseul-unic-dashboard')">
                            <img class="sidenav-request-btn" src="/assets/icons/rapoarte.svg" alt="" />
                            <span>Dashboard</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.ghiseu.list')"
                            class="settings-option-menu" routerLink="/ghiseul-unic-cereri"
                            [class.menu-active]="'/ghiseul-unic-cereri' === activeOption"
                            (click)="setActive('/ghiseul-unic-cereri')">
                            <img class="sidenav-request-btn" src="/assets/icons/cereri.svg" alt="" />
                            <span>Solicitări</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.ghiseu.ghiseu-programari.list')"
                            class="settings-option-menu" routerLink="/ghiseul-unic-programari"
                            [class.menu-active]="'/ghiseul-unic-programari' === activeOption"
                            (click)="setActive('/ghiseul-unic-programari')">
                            <img class="sidenav-request-btn" src="/assets/icons/programari.svg" alt="" />
                            <span>Programări</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.ghiseu.notificari-ghiseu.list')"
                            class="settings-option-menu" routerLink="/ghiseul-unic-notificari"
                            [class.menu-active]="'/ghiseul-unic-notificari' === activeOption"
                            (click)="setActive('/ghiseul-unic-notificari')">
                            <img class="sidenav-request-btn" src="/assets/icons/notificari.svg" alt="" />
                            <span>Notificări</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.ghiseu.borderou-automat.list')"
                            class="settings-option-menu" routerLink="/ghiseul-unic-borderouri-automate"
                            [class.menu-active]="'/ghiseul-unic-borderouri-automate' === activeOption"
                            (click)="setActive('/ghiseul-unic-borderouri-automate')">
                            <img class="sidenav-request-btn" src="/assets/icons/borderou.svg" alt="" />
                            <span>Borderouri Automate</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('auth-module.ghiseu-settings.access-ghiseu')"
                            class="settings-option-menu" routerLink="/ghiseul-unic-settings"
                            [class.menu-active]="'/ghiseul-unic-settings' === activeOption"
                            (click)="setActive('/ghiseul-unic-settings')">
                            <img src="/assets/icons/settings.svg" alt="" />
                            <span>Setări</span>
                        </p>

                        <mat-expansion-panel
                            *ngIf="permissionsService.hasPermission('auth-module.ghiseu.ghiseu-programari.list')"
                            class="sidenav-accordion" (opened)="panelOpenState6 = true"
                            (closed)="panelOpenState6 = false">
                            <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState6">
                                <mat-panel-title class="sidenav-accordion">
                                    <img src="../../../../assets/icons/programari.svg" alt="" />
                                    <span> Calendar</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <mat-expansion-panel *ngFor="let module of sidenavService.getGhiseuModules()"
                                class="sidenav-accordion" (opened)="panelOpenState = true"
                                (closed)="panelOpenState = false">
                                <mat-expansion-panel-header class="sidenav-accordion">
                                    <mat-panel-title class="sidenav-accordion">
                                        <div class="panel-title panel-title-overflow">
                                            <img src="../../../../assets/icons/programari.svg" alt="" />
                                            <span> {{ module.name }}</span>
                                        </div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>

                                <ng-container *ngFor="let locatieActiva of sidenavService.getGhiseuLocatiiActive()">
                                    <p *ngIf="locatieActiva.id_modul === module.id" class="settings-option-menu"
                                        [class.menu-active]="('/ghiseul-unic-programari-view/' + locatieActiva.id) === activeOption"
                                        (click)="navigateToProgramariView(module.id, locatieActiva.id_locatie)">
                                        <img src="../../../../assets/icons/location-dot-solid.svg" alt="" />
                                        <span>{{ locatieActiva.nume_locatie }}</span>
                                    </p>
                                </ng-container>
                            </mat-expansion-panel>
                        </mat-expansion-panel>
                    </mat-expansion-panel>
                    <mat-expansion-panel class="sidenav-accordion" (opened)="panelOpenState2 = true"
                        (closed)="panelOpenState2 = false">
                        <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState2">
                            <mat-panel-title class="sidenav-accordion">
                                <img src="/assets/icons/administrative.svg" alt="" />
                                <span>Administrativ</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p class="settings-option-menu" routerLink="/admin-settings"
                            [class.menu-active]="'/admin-settings' === activeOption"
                            (click)="setActive('/admin-settings')">
                            <img src="/assets/icons/settings.svg" alt="" />
                            <span>Setări</span>
                        </p>
                    </mat-expansion-panel>
                </mat-accordion>

                <div class="footer">
                    <div class="col-sm-12 px-2" [class.hidden]="isCollapsed == true">
                        <small [innerHTML]="env.config.copyrightText"></small>
                    </div>
                    <div class="logout-button" (click)="logout()">
                        <img src="assets/icons/logout.svg" alt="Deconectare" />
                        <div class="logout-button--text">Deconectare</div>
                    </div>
                </div>
            </div>
        </mat-drawer>
        <mat-drawer-content class="drawer-content" [style.marginLeft.px]="isCollapsed ? 85 : 280">
            <router-outlet></router-outlet>
        </mat-drawer-content>
    </mat-drawer-container>
</div>